// Shared fallbacks for mapStateToProps and selectors. connect re-renders a
// component when any prop is not === to last time, so a `?? {}` / `? [] :`
// literal hands it a fresh object on every dispatch and the row re-renders
// with nothing changed. These are created once; frozen because every consumer
// shares the same instance.
export const EMPTY_OBJECT = Object.freeze({});
export const EMPTY_ARRAY = Object.freeze([]);
